import { AdminSearchContent } from '@/client/types/admin/AdminSearchContent';
import { User } from '@/client/services/api/graphql/gql/graphql';

export type TextQuery = {
  id: string;
  __typename: 'textQuery';
  title: string;
};

export type SearchItem =
  | { __typename: 'User'; id: string; fullName: string; image?: string }
  | { __typename: 'AdminSearchContent'; id: string; title: string; type: string; image?: string }
  | TextQuery;

export type SearchGroup = {
  label: string;
  options: SearchItem[];
};

export const convertUserToSearchItem = (user: User): SearchItem => ({
  __typename: 'User',
  id: user.id,
  fullName: user.fullName || '',
  image: user.image || undefined,
});

export const convertAdminContentToSearchItem = (content: AdminSearchContent): SearchItem => ({
  __typename: 'AdminSearchContent',
  id: content._id,
  title: content.title,
  type: content.type,
  image: content.image,
});

export const createTextQuery = (title: string): TextQuery => ({
  id: `text-${Date.now()}`,
  __typename: 'textQuery',
  title,
});

export type Filter = 'assignments' | 'users' | 'content';

export type FilterOption = {
  label: string;
  value: Filter;
};
